export const FAVORITE_TYPES = {
  PARTNER: 'partner',
};
